// extracted by mini-css-extract-plugin
export default {"classificationSelector":"ForSaleHorses_classificationSelector__sUfz8","active":"ForSaleHorses_active__ihmML","separator":"ForSaleHorses_separator__ZCPlG"};